import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { CUSTOM_ID } from '@nw/shared/config';
import { getAPIErrorMessage, getURLSearchParam } from '@nw/shared/utils';

import {
  CreatePublicIbFormSubmissionRequestType,
  CreatePublicIbFormSubmissionResponseType
} from '../../../services/FormsServices/APIService/types';

import { useFormsService } from '../useFormsService';

interface UseCreatePublicIbFormSubmissionResponseInterface {
  createPublicIbFormSubmissionAPI: UseMutateAsyncFunction<
    CreatePublicIbFormSubmissionResponseType,
    unknown,
    CreatePublicIbFormSubmissionRequestType,
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useCreatePublicIbFormSubmission =
  (): UseCreatePublicIbFormSubmissionResponseInterface => {
    const { formsServiceAPI } = useFormsService();

    const createPublicIbFormSubmission = (
      request: CreatePublicIbFormSubmissionRequestType
    ) => {
      const customId = getURLSearchParam().get(CUSTOM_ID);
      if (customId) {
        request.form_submission_data = JSON.stringify({
          ...JSON.parse(request.form_submission_data),
          custom_id: customId
        });
      }
      return formsServiceAPI.createPublicIbFormSubmission(request);
    };

    const { mutateAsync, error, status } = useMutation(
      createPublicIbFormSubmission,
      {
        mutationKey: ['createPublicIbFormSubmissionAPI']
      }
    );

    return {
      createPublicIbFormSubmissionAPI: mutateAsync,
      error: error ? getAPIErrorMessage(error) : '',
      status
    };
  };

export { useCreatePublicIbFormSubmission };
